/* TLH — accueil : « Leurs ouvertures » (bande vidéo) et « La parole aux collectionneurs » (double défilé d'avis).
   Repris de l'ATELIER le 29/10/2026. Construit à partir des sections existantes (Stories et Avis) : les modifier dans l'éditeur met à jour l'accueil
   (ordre de la bande = ordre des stories ; couverture = miniature de story). Les sections d'origine sont seulement masquées (classe tlh-v-off).
   Affiches chargées à l'approche de la section, vidéo 480p chargée au toucher seulement. Pour annuler : retirer la ligne tlh-ouvertures de layout/theme.liquid. */
/* Perf 30/10 : la bande vidéo et le défilé d'avis (sous la bannière) ne se construisent qu'une fois la page chargée et le téléphone libre,
   pour ne pas retarder l'affichage de la bannière. */
/* 01/11/2026 (Hugo, vidéo Instagram) : sur iPhone (Safari et navigateur d'Instagram), pas d'« ancrage du défilement » : quand ces deux
   blocs (≈ 775 px de plus que les sections d'origine sur téléphone) apparaissaient au-dessus de l'endroit lu, l'écran revenait
   d'autant en arrière. Désormais : construction au premier geste (le visiteur est encore en haut de page) ou après le chargement,
   au premier des deux ; et si le visiteur est déjà plus bas, la position de lecture est conservée (compensation du défilement). */
await new Promise(function (r) {
  var done = false, go = function () { if (done) return; done = true; r(); };
  ['scroll', 'touchstart', 'pointerdown', 'keydown'].forEach(function (t) { window.addEventListener(t, go, { once: true, passive: true, capture: true }); });
  var idle = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 1); })(go, { timeout: 1500 }); };
  if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle, { once: true });
});
var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var TOUCH = window.matchMedia('(hover: none)').matches;
var $ = function (s, r) { return (r || document).querySelector(s); };
var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
var esc = function (t) { return String(t || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
var once = function (el, fn, th) {
  if (!('IntersectionObserver' in window)) { fn(el); return; }
  var o = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { o.unobserve(e.target); fn(e.target); } }); }, { threshold: th || 0.3 });
  o.observe(el);
};
var block = function (cls, html) {
  var s = document.createElement('section');
  s.className = 'tlh-v ' + cls;
  s.innerHTML = html;
  return s;
};
var eyebrow = function (t) { return '<p class="tlh-v__eyebrow">' + t + '</p>'; };

function loadCss() {
  return new Promise(function (ok) {
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = new URL('tlh-ouvertures.css?v=1', import.meta.url).href;
    l.onload = ok; l.onerror = ok;
    document.head.appendChild(l);
    setTimeout(ok, 2500);
  });
}

/* ---------------- Ouvertures : la pellicule ---------------- */
var SD = {
  /* sélection d'accueil du 29/10/2026, dans l'ordre de la bande (version 480p servie au toucher) */
  '809c618473b6402fad7d78bae02a2a67': 'SD-480p-1.2Mbps-99309481', /* 01 L'ORIGINAL */
  'ad03c5c9a9c44124aacb4a1dbbb83484': 'SD-480p-1.5Mbps-99309482', /* 02 L'ORIGINAL à la table */
  '31acd901e6a14b6fa1a66a3620c9c0ba': 'SD-480p-1.2Mbps-99309483', /* 03 THE JUST-AR */
  '61d9c760ac8b45c0b52cfc0dc7522367': 'SD-480p-1.5Mbps-99309485', /* 04 THE JUST-SAR */
  '039829981120467fba4a95d4e2420d9d': 'SD-480p-1.5Mbps-99309486', /* 05 THE GOD PACK */
  '9eea47d718b040e7bc958d4dde650509': 'SD-480p-1.0Mbps-99309487'  /* 06 Le témoignage */
};
/* anciennes vidéos (réactivées le 29/10) */
SD['9d171a2f69c24d61a77f68cd9e4e6c92'] = 'SD-480p-0.9Mbps-91509561';
SD['4045d2de228c432c98e4a6935723a84b'] = 'SD-480p-1.0Mbps-91509888';
SD['7f2ce5e5735f4c1ea9b036358f3da7ab'] = 'SD-480p-1.5Mbps-82865527';
SD['addcc4a2cb7d4a10a15b5a4653da2e4a'] = 'SD-480p-1.0Mbps-91510127';
SD['32c6c5f423884995a2337d3d500e047c'] = 'SD-480p-0.9Mbps-91509799';
function buildFilm() {
  var src = $('[id$="__custom_section_rnyFnU"]');
  if (!src) return;
  var vids = $$('video', src);
  $$('template', src).forEach(function (t) { vids = vids.concat($$('video', t.content)); });
  /* miniature de story posée dans l'éditeur (bloc Story > miniature) : elle devient la couverture de la vidéo */
  var THUMB = {}, bubbles = $$('button.story', src), tpls = $$('template[data-ref="story-content"]', src);
  bubbles.forEach(function (bt, i) {
    var im = $('.story__bubble img', bt), t = tpls[i];
    if (!im || !t) return;
    var u = im.getAttribute('src') || '';
    if (!u || /\.thumbnail\./.test(u)) return;
    $$('video', t.content).forEach(function (v) {
      var s0 = $('source', v), vu = (s0 && s0.getAttribute('src')) || v.getAttribute('src') || '';
      var mm = vu.match(/vp\/([0-9a-f]{32})\//);
      if (mm) THUMB[mm[1]] = u;
    });
  });
  var seen = {}, list = [];
  vids.forEach(function (v) {
    var s = $('source', v), url = (s && s.getAttribute('src')) || v.getAttribute('src');
    if (!url) return;
    var m = url.match(/vp\/([0-9a-f]{32})\/\1\.([^.]+(?:\.\d+)?[^.]*)\.mp4/);
    var id = m ? m[1] : url;
    if (seen[id]) return;
    seen[id] = 1;
    if (m && SD[id]) url = url.replace(m[2], SD[id]);
    var pst = THUMB[id] || v.getAttribute('poster') || '';
    list.push({ id: id, src: url, poster: pst });
  });
  if (!list.length) return;
  /* ordre de la bande = ordre des stories dans l'éditeur (29/10, demande de Hugo) */
  var b = block('tlh-v--film',
    '<div class="tlh-v__in tlh-v__film">' +
    '<div class="tlh-v__film-l">' + eyebrow('Filmées par la communauté') +
    '<h2 class="tlh-v__h2">Leurs <span class="tlh-v__or">ouvertures</span></h2>' +
    '<p class="tlh-v__live"><i></i>De vraies ouvertures, de vrais hits</p>' +
    '<a class="button tlh-da-cta" href="/collections/nos-boosters">Ouvre le tien</a>' +
    '<p class="tlh-v__hint">' + (TOUCH ? 'Touche une ouverture pour la regarder' : 'Clique sur une ouverture pour la regarder') + '</p></div>' +
    '<div class="tlh-v__reel"><div class="tlh-v__track"></div></div></div>');
  src.after(b);
  src.classList.add('tlh-v-off');

  /* juste assez de vignettes pour remplir la bande, doublées pour la boucle.
     Rien ne se télécharge tant que le client ne touche pas une ouverture : la bande défile avec les affiches. */
  var reel = $('.tlh-v__reel', b), track = $('.tlh-v__track', b);
  var cw = window.innerWidth < 750 ? 162 : 206;
  var half = list.slice();
  while (half.length * cw < reel.clientWidth + cw) half = half.concat(list);
  /* affiches servies à la taille exacte de la vignette sur l'écran du client (300 px sur téléphone, 380 px sur ordinateur Retina, 200 px sur écran classique) */
  var PW = Math.min(400, Math.ceil((cw - (cw < 200 ? 12 : 16)) * Math.min(window.devicePixelRatio || 1, 2) / 20) * 20);
  var poster = function (u) {
    if (!u || !/\/cdn\/shop\/|cdn\.shopify\.com/.test(u) || /\/assets\//.test(u)) return u;
    if (/_\d+x\.(jpe?g|png|webp)/i.test(u)) return u.replace(/_\d+x\.(jpe?g|png|webp)/i, '_' + PW + 'x.$1');
    return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=' + PW) : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + PW;
  };
  var clip = function (c) { return '<button type="button" class="tlh-v__clip" aria-label="Regarder cette ouverture"><video playsinline preload="none" data-poster="' + esc(poster(c.poster)) + '" data-src="' + esc(c.src) + '"></video><span class="tlh-v__play" aria-hidden="true"></span></button>'; };
  track.innerHTML = half.map(clip).join('') + half.map(clip).join('');
  track.style.animationDuration = Math.round(half.length * cw / 34) + 's';
  /* la bande reste immobile tant que le client n'est pas arrivé dessus : il voit la 1re vidéo en premier */
  if ('IntersectionObserver' in window) {
    track.style.animationPlayState = 'paused';
    var go = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { go.disconnect(); track.style.animationPlayState = ''; } }, { threshold: 0.6 });
    go.observe(reel);
  }

  /* les affiches ne se chargent qu'à l'approche de la section (environ un écran avant) */
  var showPosters = function () { $$('video[data-poster]', track).forEach(function (v) { v.poster = v.dataset.poster; v.removeAttribute('data-poster'); }); };
  if ('IntersectionObserver' in window) {
    var po = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { po.disconnect(); showPosters(); } }, { rootMargin: '800px 0px' });
    po.observe(reel);
  } else showPosters();

  /* une seule ouverture joue à la fois, avec le son ; re-toucher la met en pause */
  var clips = $$('.tlh-v__clip', track), cur = null;
  var stop = function () {
    if (!cur) return;
    var v = $('video', cur);
    v.pause();
    cur.classList.remove('is-play');
    cur = null;
  };
  clips.forEach(function (c) {
    var v = $('video', c);
    v.addEventListener('ended', function () { if (cur === c) stop(); });
    c.addEventListener('click', function () {
      if (cur === c) { stop(); return; }
      stop();
      if (!v.getAttribute('src')) v.src = v.dataset.src;
      v.muted = false;
      cur = c;
      c.classList.add('is-play');
      var p = v.play();
      if (p) p.catch(function () { v.muted = true; v.play().catch(function () { stop(); }); });
    });
  });
  /* la vidéo s'arrête quand on quitte la section */
  if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { if (!es[0].isIntersecting) stop(); }, { threshold: 0.1 }).observe(reel);
}

/* ---------------- Avis : le double défilé ---------------- */
function buildReviews() {
  var src = $('[id$="__reviews_j47daG"]') || $('.shopify-section.section-reviews');
  if (!src) return;
  var revs = $$('.review', src).map(function (r) {
    var c = $('.review__content', r);
    var t = c ? c.innerHTML.replace(/<br\s*\/?>/gi, ' ').replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim() : '';
    return { text: t, author: ($('.review__author-name', r) || {}).textContent || '', date: ($('.review__date', r) || {}).textContent || '' };
  }).filter(function (r) { return r.text; });
  if (!revs.length) return;
  var badge = $('.reviews-badge', src);
  var badgeHtml = badge ? '<div class="tlh-v__badge">' + badge.outerHTML + '</div>' : '';
  var stars = '<span class="tlh-v__stars" aria-label="5 étoiles sur 5">★★★★★</span>';
  var card = function (r) { return '<article class="tlh-v__rc">' + stars + '<p>' + esc(r.text) + '</p><footer><b>' + esc(r.author.trim()) + '</b><span>' + esc(r.date.trim()) + '</span></footer></article>'; };
  var mid = Math.ceil(revs.length / 2), r1 = revs.slice(0, mid), r2 = revs.slice(mid);
  if (!r2.length) r2 = r1;
  while (r1.length < 5) r1 = r1.concat(r1);
  while (r2.length < 5) r2 = r2.concat(r2);
  var c2 = block('tlh-v--rows',
    '<div class="tlh-v__in">' + eyebrow('Ils en parlent') +
    '<h2 class="tlh-v__h2">La parole <span class="tlh-v__or">aux collectionneurs</span></h2>' + badgeHtml + '</div>' +
    '<div class="tlh-v__rows"><div class="tlh-v__row">' + r1.map(card).join('') + r1.map(card).join('') + '</div>' +
    '<div class="tlh-v__row tlh-v__row--rev">' + r2.map(card).join('') + r2.map(card).join('') + '</div></div>');
  src.after(c2);
  src.classList.add('tlh-v-off');
}

/* Repère de lecture : l'élément au milieu de l'écran (hors en-tête, fenêtres et barres fixes, hors sections remplacées) */
var repere = function () {
  if (window.scrollY < 1) return null;
  var el = document.elementFromPoint(window.innerWidth / 2, window.innerHeight / 2);
  if (!el || el.closest('header, .header, dialog, .tlh-v-off, [id$="__custom_section_rnyFnU"], [id$="__reviews_j47daG"]')) return null;
  for (var p = el; p && p !== document.body; p = p.parentElement) { if (getComputedStyle(p).position === 'fixed') return null; }
  return el;
};
var start = function () {
  loadCss().then(function () {
    var a = repere(), y0 = a ? a.getBoundingClientRect().top : 0;
    try { buildFilm(); } catch (e) { console.warn('[TLH ouvertures] pellicule', e); }
    try { buildReviews(); } catch (e) { console.warn('[TLH ouvertures] avis', e); }
    /* iPhone : on garde l'endroit lu (Chrome le fait déjà seul, l'écart mesuré y est alors nul) */
    if (a && a.isConnected) { var d = a.getBoundingClientRect().top - y0; if (Math.abs(d) > 1) window.scrollBy(0, d); }
  });
};
start();
